import { Injectable } from '@angular/core';
import { Service } from 'src/app/core/jsonapi/service';
import { WorkerFile } from '../_types/worker-file';
import { WorkerFileType } from '../_types/worker-file-type';

@Injectable({
  providedIn: 'root'
})
export class WorkersFilesTypesService  extends Service<WorkerFileType> {
  public override type = 'workerFileTypes';
  public override url = 'providers/workerFileTypes';
  
}